export default __webpack_public_path__ + "static/getpaid-listing-9b85795c3de5943ac6df94661ef729bb.png";